import React from "react";
import {connect} from "react-redux";
import './Empty.css';
import {Link} from 'react-router-dom'
import {fetchJiraUnitsResults} from "../../actions/searchActions";
import Loading from '../Shared/Loading';
import Pagination from '../Pagination/Pagination';
import queryString from "query-string";
import moment from 'moment';

class JiraUnits extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.dispatch(fetchJiraUnitsResults(1));
    };

    componentDidUpdate(prevProps) {
        let query = this.props.location.search;
        let queryParams = queryString.parse(query);
        let nextPage = typeof queryParams.page !== 'undefined' && !isNaN(queryParams.page) ? parseInt(queryParams.page, 10) : 1;
        let prevPage = parseInt(prevProps.pagination.current_page, 10);
        if (prevPage !== nextPage && !this.props.loading) {
            this.props.dispatch(fetchJiraUnitsResults(nextPage));
        }
    }

    render() {
        const {pagination, loading, units} = this.props;
        return (
            <div className="campaign-info jira-info">
                {this.props.loading ? <Loading/> :
                    <div>
                        <div className="jira_header">
                            <h2># of unpublished Jira units: {pagination.total_records}</h2>
                            <Pagination
                                totalRecords={pagination.total_records}
                                pageLimit={pagination.page_limit}
                                currentPage={pagination.current_page}
                                totalPages={pagination.total_pages}
                                loading={loading}
                                route="/manage/jira_units"
                            />
                        </div>
                        <table className="table jira-table">
                            <thead>
                            <tr>
                                <th>Mock Units</th>
                                <th>Designer</th>
                                <th>Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            {units.length !== 0 ? units.map((unit, k) => {
                                return (
                                    <tr key={k}>
                                        <td><Link key={k} to={`/mock/${unit.id}`}>{unit.name} - {unit.creative_type_name} {unit.media_label !== null ? "- " + unit.media_label : ""}
                                        </Link></td>
                                        <td>{unit.designer}</td>
                                        <td>{moment(unit.date).format('MMMM YYYY')}</td>
                                    </tr>
                                )
                            }) : <tr>
                                <td style={{flexBasis: '100%'}}><h3>There are no unpublished JIRA units.</h3></td>
                            </tr>}
                            </tbody>
                        </table>
                        <div className="jira_footer">
                            <Pagination
                                totalRecords={pagination.total_records}
                                pageLimit={pagination.page_limit}
                                currentPage={pagination.current_page}
                                totalPages={pagination.total_pages}
                                loading={loading}
                                route="/manage/jira_units"
                            />
                        </div>
                    </div>
                }
            </div>

        )
    }
}

const mapStateToProps = state => ({
    units: state.search.units,
    pagination: state.search.pagination,
    loading: state.search.loading,
});
export default connect(mapStateToProps)(JiraUnits);
